import React from 'react';
import {
    Redirect
  } from "react-router-dom";
import API from '../API.js'

export default class Logout extends React.Component{
    componentDidMount(){
        this.props.sessionDidUpdate(false)
        API.logout()
    }

    render(){
        return (
        (<Redirect to="/login" />)
        )
    }
}